var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVisitRecords = function SvgVisitRecords(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-250.000000, -298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Teleconsult",
    transform: "translate(230.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teleconsult-List",
    transform: "translate(0.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,17 L4,20 L7,20 L7,22 L4,22 C2.9,22 2,21.1 2,20 L2,17 L4,17 Z M22,17 L22,20 C22,21.05 21.1799587,21.9177686 20.1486946,21.9944872 L20,22 L17,22 L17,20 L20,20 L20,17 L22,17 Z M12,4.75 C14.9025,4.75 17.25,7.0975 17.25,10 C17.25,13.9375 12,19.75 12,19.75 C12,19.75 6.75,13.9375 6.75,10 C6.75,7.0975 9.0975,4.75 12,4.75 Z M12,8.125 C10.965,8.125 10.125,8.965 10.125,10 C10.125,11.035 10.965,11.875 12,11.875 C13.035,11.875 13.875,11.035 13.875,10 C13.875,8.965 13.035,8.125 12,8.125 Z M7,2 L7,4 L4,4 L4,7 L2,7 L2,4 C2,2.95 2.82004132,2.0822314 3.85130541,2.00551277 L4,2 L7,2 Z M20,2 C21.1,2 22,2.9 22,4 L22,7 L20,7 L20,4 L17,4 L17,2 L20,2 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisitRecords, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visit-records.8ac36271.svg";
export { ForwardRef as ReactComponent };